import { render, staticRenderFns } from "./vehicleDeviationTable.vue?vue&type=template&id=caf1e498&scoped=true&"
import script from "./vehicleDeviationTable.vue?vue&type=script&lang=js&"
export * from "./vehicleDeviationTable.vue?vue&type=script&lang=js&"
import style0 from "./vehicleDeviationTable.vue?vue&type=style&index=0&id=caf1e498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf1e498",
  null
  
)

export default component.exports